import { render, staticRenderFns } from "./pre-buy-whitelist-import.vue?vue&type=template&id=48d5e79d&scoped=true&"
import script from "./pre-buy-whitelist-import.vue?vue&type=script&lang=js&"
export * from "./pre-buy-whitelist-import.vue?vue&type=script&lang=js&"
import style0 from "./pre-buy-whitelist-import.vue?vue&type=style&index=0&id=48d5e79d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5e79d",
  null
  
)

export default component.exports